<template>
  <SettingsModal
    v-bind="{ isVisible }"
    :headline="$t(`licensedterritory.${licensedTerritory}`)"
    icon="location"
    :tracking="{
      action: 'state_switch',
      topicKey: 'state_selection',
      customMessage: trackingOptions,
      customTopic: $t(`licensedterritory.${licensedTerritory}`),
    }"
    @close="isVisible = false"
  >
    <div>
      <LcSelectList v-bind="{ options }" v-model:value="modelValue" />
    </div>

    <template #footer>
      <div class="-my-100 -mr-100">
        <LanguageSwitch @option-click="isVisible = false" />
      </div>
    </template>
  </SettingsModal>
</template>

<script lang="ts" setup>
import type { LcSelectListOption } from '@lottocom/frontend-components'

const { licensedTerritory, options } = useStateSwitch()

const isVisible = defineModel('isVisible', { default: false, type: Boolean })

const modelValue = computed({
  get: () => licensedTerritory,
  set: (newValue: LcSelectListOption['value']) => {
    if (newValue) return
    isVisible.value = false
  },
})

const trackingOptions = computed(() => options.value.map(({ label }) => label).join(', '))
</script>
